// 차량 색상 프리셋 (2026-04-22) — CRA src/ 밖 import 제약 회피용 클라이언트 로컬 사본
// 단일 진실 원천: /utils/carColors.js (서버) — 프리셋 변경 시 양쪽 동시 수정 필수
// 변경 빈도 낮음 (2026-04-22 확정 이후 추가 색상 요청 시에만)

export var CAR_COLOR_PRESETS = [
  { key: 'white',    label: '\uD770\uC0C9',   hex: '#FFFFFF', border: '#d1d5db' },
  { key: 'black',    label: '\uAC80\uC815',   hex: '#1f2937' },
  { key: 'silver',   label: '\uC740\uC0C9',   hex: '#C0C0C0' },
  { key: 'gray',     label: '\uD68C\uC0C9',   hex: '#6b7280' },
  { key: 'darkgray', label: '\uC950\uC0C9',       hex: '#374151' },
  { key: 'red',      label: '\uBE68\uAC15',   hex: '#dc2626' },
  { key: 'blue',     label: '\uD30C\uB791',   hex: '#2563eb' },
  { key: 'navy',     label: '\uB0A8\uC0C9',   hex: '#1e3a8a' },
  { key: 'green',    label: '\uCD08\uB85D',   hex: '#16a34a' },
  { key: 'beige',    label: '\uBCA0\uC774\uC9C0', hex: '#d4b896' },
  { key: 'yellow',   label: '\uB178\uB791',   hex: '#eab308' },
  { key: 'other',    label: '\uAE30\uD0C0',   hex: '#9ca3af' },
];

export function getColorHex(label) {
  if (!label) return null;
  for (var i = 0; i < CAR_COLOR_PRESETS.length; i++) {
    if (CAR_COLOR_PRESETS[i].label === label) return CAR_COLOR_PRESETS[i].hex;
  }
  return null;
}

export function getColorBorder(label) {
  if (!label) return null;
  for (var i = 0; i < CAR_COLOR_PRESETS.length; i++) {
    if (CAR_COLOR_PRESETS[i].label === label) {
      return CAR_COLOR_PRESETS[i].border || CAR_COLOR_PRESETS[i].hex;
    }
  }
  return null;
}
